<!-- Classes main-div and example-card are catagorized in .css file -->
<div class="login-header">
  <div class="language-item row">
    <button type="button" class="select-language" [matMenuTriggerFor]="menu" (menuOpened)="isOpen = true" (menuClosed)="isOpen = false">
      <div>
        <img *ngIf="currentLanguage == 'vi'" class="vt-cursor-pointer" src="../../../assets/images/vn.svg" alt="vietnamese" width="30" height="20">
        <img *ngIf="currentLanguage == 'en'" class="vt-cursor-pointer" src="../../../../assets/images/en.svg" alt="english" width="30" height="20">
        <img *ngIf="currentLanguage == 'zh'" class="vt-cursor-pointer" src="../../../assets/images/china.svg" alt="china" width="30" height="20">
        <img *ngIf="currentLanguage == 'es'" class="vt-cursor-pointer" src="../../../assets/images/es.svg" alt="es" width="30" height="20">
      </div>
      <span class="">{{getCurrentNameLanguage()}}</span>
      <div class="">
          <em *ngIf="isOpen" class="material-icons">keyboard_arrow_up</em>
          <em *ngIf="!isOpen" class="material-icons">keyboard_arrow_down</em>
      </div>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="onChangeLanguage('vi')" style="width: 140px;"
          [ngClass]="{'active-btn': currentLanguage == 'vi'}">
          <img class="vt-cursor-pointer" src="./assets/images/vn.svg" alt="vietnamese" width="30" height="20">
          {{'Tiếng Việt' | translate}}
      </button>
      <button mat-menu-item (click)="onChangeLanguage('en')" style="width: 140px;"
          [ngClass]="{'active-btn': currentLanguage == 'en'}">
          <img class="vt-cursor-pointer" src="./assets/images/en.svg" alt="english" width="30" height="20">
          {{'English' | translate}}
      </button>
      <button mat-menu-item (click)="onChangeLanguage('zh')" style="width: 140px;"
          [ngClass]="{'active-btn': currentLanguage == 'zh'}">
          <img class="vt-cursor-pointer" src="./assets/images/china.svg" alt="china" width="30" height="20">
          {{'中国人' | translate}}
      </button>
      <button mat-menu-item (click)="onChangeLanguage('es')" style="width: 140px;"
          [ngClass]="{'active-btn': currentLanguage == 'es'}">
          <img class="vt-cursor-pointer" src="./assets/images/es.svg" alt="spanish" width="30" height="20">
          {{'Español' | translate}}
      </button>
    </mat-menu>
  </div>
</div>
<div class="login-wrapper">
  <mat-card class="login-card">
    <form name="form" #f="ngForm" (ngSubmit)="f.form.valid && resetPwd()"
          [mustMatch]="['newPassword', 'confirmPassword']" appFocusFirstElement>
      <mat-card-header>
        <div mat-card-avatar class="text-center">
          <img alt="Logo" src="../../../../assets/images/logo_vcontract.png">
          <div _ngcontent-yva-c7="" class="expired-password text-center" *ngIf="passwordExpired===1">
            <strong>{{'change_password.password_expired' | translate}}</strong>
          </div>
          <div _ngcontent-yva-c7="" class="vt-text-login-header text-center"><strong>{{'header.change_password' | translate | uppercase }}</strong></div>
        </div>
      </mat-card-header>
      <mat-card-content class="pt-2">
        <mat-form-field class="w-100" *ngIf="passwordExpired===1">
          <button matSuffix mat-icon-button color="primary" type="button" (click)="currentPasswordVisibility = !currentPasswordVisibility">
            <mat-icon>{{!currentPasswordVisibility ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <input matInput [type]="currentPasswordVisibility ? 'text' : 'password'" #focusInput [placeholder]="'change_password.lbl_current_password' | translate"
            name="currentPassword" id="currentPassword" [(ngModel)]="passwordData.currentPassword"
            #currentPass="ngModel" required maxlength="100" autocomplete="off" />
          <mat-error *ngIf="f.submitted || currentPass?.errors?.required">
            <span class="text-error">{{'change_password.validation.current_pass_required' | translate}}</span>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="w-100">
          <button matSuffix mat-icon-button color="primary" type="button" (click)="clickVisibility()">
            <mat-icon>{{!newPasswordVisibility ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <input #focusInput matInput [type]="newPasswordVisibility ? 'text' : 'password'" [placeholder]="'change_password.lbl_new_password' | translate"
                 name="newPassword" id="newPassword" [(ngModel)]="passwordData.newPassword" #newPass="ngModel" required
                 [pattern]="strengthPattern"
                 passwordPattern
                 (focus)="onFocus()"
                 (blur)="onBlur()"
                 minlength="8"
                 maxlength="100" (focusout)="passwordData.newPassword = passwordData.newPassword.trim()" autocomplete="off" />
                 <!-- passwordData.newPassword = passwordData.newPassword.trim() -->
         <!-- validate new password -->

          <mat-hint  class="line-hint" *ngIf="isTouch && ((!isFocusNewPassword && newPass.invalid) || isFocusNewPassword)">
            <div class="line-warning">
              <mat-icon class="hint-icon green-icon" color="primary" *ngIf="!newPass?.errors?.pattern && !newPass?.errors?.required && newPass.dirty">check_circle_outline</mat-icon>
              <mat-icon class="hint-icon" color="warn" *ngIf="(newPass?.errors?.pattern || newPass?.errors?.required) && newPass.dirty">highlight_off</mat-icon>
              <mat-icon class="hint-icon" *ngIf="!newPass.dirty">check_circle_outline</mat-icon>
              <span style="padding-left: 5px" [ngClass]="!newPass.dirty? 'text-primary' :!newPass?.errors?.pattern && !newPass?.errors?.required ? 'text-primary green-icon' : 'text-warn'">{{'change_password.validation.strength' | translate}}</span>
            </div>
          </mat-hint>

          <!-- minlength=8 -->
          <mat-hint  *ngIf="isTouch && ((!isFocusNewPassword && newPass.invalid) || isFocusNewPassword)">
            <div class="line-warning">
              <mat-icon class="hint-icon green-icon" color="primary" *ngIf="!newPass?.errors?.minlength && !newPass?.errors?.required && newPass.dirty">check_circle_outline</mat-icon>
              <mat-icon class="hint-icon" color="warn" *ngIf="(newPass?.errors?.minlength || newPass?.errors?.required) && newPass.dirty">highlight_off</mat-icon>
              <mat-icon class="hint-icon" *ngIf="!newPass.dirty">check_circle_outline</mat-icon>
              <span style="padding-left: 5px" [ngClass]="!newPass.dirty? 'text-primary' : !newPass?.errors?.minlength && !newPass?.errors?.required ? 'text-primary green-icon' : 'text-warn'">{{'change_password.validation.at_least_8_letter' | translate}}</span>
            </div>
          </mat-hint>

          <!-- minlength=8 -->
          <mat-hint  *ngIf="isTouch && ((!isFocusNewPassword && newPass.invalid) || isFocusNewPassword)">
            <div class="line-warning">
              <mat-icon class="hint-icon green-icon" color="primary" *ngIf="!newPass?.errors?.invalidContainPattern && !newPass?.errors?.required && newPass.dirty">check_circle_outline</mat-icon>
              <mat-icon class="hint-icon" color="warn" *ngIf="newPass.dirty && (newPass?.errors?.invalidContainPattern || newPass?.errors?.required)">highlight_off</mat-icon>
              <mat-icon class="hint-icon" *ngIf="!newPass.dirty">check_circle_outline</mat-icon>
              <span style="padding-left: 5px" [ngClass]="!newPass.dirty? 'text-primary' : !newPass?.errors?.invalidContainPattern && !newPass?.errors?.required ? 'text-primary green-icon' : 'text-warn'">{{'change_password.validation.not_contain' | translate}}</span>
            </div>
          </mat-hint>





        <!-- end validate new password -->

          <!-- <mat-error *ngIf="newPass?.errors?.required">
            <span class="text-error">{{'change_password.validation.new_pass_required' | translate}}</span>
          </mat-error>
          <mat-error *ngIf="newPass?.errors?.notMatch">
            <span class="text-error">{{'change_password.validation.not_match' | translate}}</span>
          </mat-error> -->
          <!-- <mat-error *ngIf="newPass?.errors?.pattern">
            <span class="text-error">{{'change_password.validation.strength' | translate}}</span>
          </mat-error> -->
        </mat-form-field>



        <mat-form-field class="w-100">
          <button matSuffix mat-icon-button color="primary" type="button" (click)="confirmPasswordVisibility = !confirmPasswordVisibility">
            <mat-icon>{{!confirmPasswordVisibility ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <input matInput [type]="confirmPasswordVisibility ? 'text' : 'password'" [placeholder]="'change_password.lbl_new_password_confirm' | translate"
                 name="confirmPassword" id="confirmPassword" [(ngModel)]="passwordData.confirmPassword"
                 #confirmPass="ngModel" required maxlength="100" (focusout)="passwordData.confirmPassword = passwordData.confirmPassword.trim()" autocomplete="off"/>
          <mat-error *ngIf="confirmPass?.errors?.required">
            <span class="text-error">{{'change_password.validation.confirm_pass_required' | translate}}</span>
          </mat-error>
          <mat-error *ngIf="confirmPass?.errors?.mustMatch">
            <span class="text-error">{{'change_password.validation.must_match' | translate}}</span>
          </mat-error>
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions class="mb-0 text-center">
        <button class="ml-2" mat-stroked-button color="primary" type="button" (click)="cancel()">
          {{'button.cancel' | translate}}
        </button>
        <button mat-raised-button style="margin-bottom: 10px !important" color="primary" type="submit" [disabled]="f.form.invalid">
          {{'confirm' | translate}}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>

<div class="login-footer">
  <div class="container-fluid py-3">
    <div class="row">
      <div class="col-12">
        <h5 class="text-white">{{'footer.contact' | translate}}</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-3 text-overflow-ellipsis">
        {{'footer.hot_line' | translate}} {{phoneNumber}}<br>{{'footer.email_detail' | translate}}
      </div>
      <div class="col-5 text-overflow-ellipsis">
        <!-- {{'footer.text_owner' | translate}}<br>{{'footer.paper' | translate}} -->
      </div>
      <div class="col-4 text-right text-overflow-ellipsis">
        {{'footer.copy-right' | translate}}<br>{{'footer.powered' | translate}}
      </div>
    </div>
  </div>
</div>
